// extracted by mini-css-extract-plugin
export var searchHeader = "_5k-0";
export var searchHeaderDark = "_5k-1";